import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { ObjectType, GxOption } from "../../common/types";
// - - - - - - - - - - - -
// Data Mappings
// - - - - - - - - - - - -

// ch-combo-box-render

export const mapObjectTypeToComboBoxItemModel = (
  objectTypeModel: ObjectType[]
): ComboBoxModel =>
  objectTypeModel.map(objectType => ({
    value: objectType.id,
    caption: objectType.name
  }));
export const mapCategoryToComboBoxItemModel = (
  categoryModel: GxOption[]
): ComboBoxModel =>
  categoryModel.map(category => ({
    value: category.id,
    caption: category.label
  }));
